import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { LicenseManager } from 'ag-grid-enterprise';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Configure AG Grid Enterprise license
LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-067930}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Fannie_Mae}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Multi}_only_for_{16}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Multi}_need_to_be_licensed___{Multi}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{18_October_2025}____[v3]_[01]_MTc2MDc0MjAwMDAwMA==d34ffe4a66d7646a16b6072b8711c7c6',
);

if (environment.production) {
  enableProdMode();
}

platformBrowser().bootstrapModule(AppModule);
